/** Documented plan tiers for marketing copy. Runtime limits come from the plans API. */
export const PLAN_MARKETING = {
  free: {
    monitors: 5,
    intervalMinutes: 5,
    priceLabel: 'Free',
    statusPages: 1,
    sslDomainMonitors: 1,
    emailRecipients: 1,
  },
  pro: {
    monitors: 20,
    intervalMinutes: 2,
    priceLabel: '$10/mo',
    statusPages: 3,
    sslDomainMonitors: 10,
    emailRecipients: 2,
  },
  max: {
    monitors: 50,
    intervalMinutes: 1,
    priceLabel: '$20/mo',
    statusPages: 10,
    sslDomainMonitors: 50,
    emailRecipients: 5,
  },
} as const

export function formatIntervalMinutes(minutes: number): string {
  if (minutes === 1) return '1 minute'
  if (minutes >= 60) return `${minutes / 60} hours`
  return `${minutes} minutes`
}

export function formatIntervalMinutesShort(minutes: number): string {
  if (minutes >= 60) return `${minutes / 60}h`
  return `${minutes}-min`
}

export function formatCheckIntervalLabel(minutes: number): string {
  if (minutes === 1) return '1-minute checks'
  return `${minutes}-minute checks`
}

export const FREE_PLAN = PLAN_MARKETING.free
